import { render, staticRenderFns } from "./nodeal.vue?vue&type=template&id=253839ac&scoped=true&"
import script from "./nodeal.vue?vue&type=script&lang=js&"
export * from "./nodeal.vue?vue&type=script&lang=js&"
import style0 from "./nodeal.vue?vue&type=style&index=0&id=253839ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253839ac",
  null
  
)

export default component.exports